<template>
    <div>
        <div v-show="is9999" class="row spacing_top">
            <div class="col-md-3 form-group">
                <label>
                    <input type="checkbox" v-model="state.autoDrawing.hasWalls" :true-value=1 :false-value=0> Side Openings
                </label>
            </div>
        </div>

        <!-- Default for everything else; 9999s will need to check a box to display this form -->
        <div v-show="!is9999 || state.autoDrawing.hasWalls">
            <img :src="`${ baseUrl }/images/auto_draw_straight.png`" class="img-responsive">

            <h3 class="spacing_btm">Wall 1</h3>

            <div class="row spacing_btm">
                <div class="col-xs-12 form-group checkbox">
                    <label>
                        <input class="btn btn-default"
                               v-model="state.autoDrawing.toggleWall1Return"
                               type=checkbox
                               :true-value=1
                               :false-value=0
                        >
                        Return Opening
                    </label>
                </div>
            </div>

            <div class="row" v-show="state.autoDrawing.toggleWall1Return">
                <div class="wall1_return">
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Return A</label>
                            <input type="text" v-model="state.autoDrawing.wall1ReturnOpenA" @keyup="checkErrors" class="form-control wall1_return_open_a">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Return B</label>
                            <input type="text" v-model="state.autoDrawing.wall1ReturnOpenB" @keyup="checkErrors" class="form-control wall1_return_open_b">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Width</label>
                            <input type="text" v-model="state.autoDrawing.wall1ReturnOpenWidth" @keyup="checkErrors" class="form-control">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Height</label>
                            <input type="text" v-model="state.autoDrawing.wall1ReturnOpenHeight" @keyup="checkErrors" class="form-control wall1_return_open_height">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row spacing_btm">
                <div class="col-xs-12 form-group checkbox">
                    <label>
                        <input class="btn btn-default"
                               v-model="state.autoDrawing.toggleWall1Supply"
                               type=checkbox
                               :true-value=1
                               :false-value=0
                        >
                        Supply Opening
                    </label>
                </div>
            </div>

            <div class="row" v-show="state.autoDrawing.toggleWall1Supply">
                <div class="wall1_supply">
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Supply C</label>
                            <input type="text" v-model="state.autoDrawing.wall1SupplyOpenC" @keyup="checkErrors" class="form-control wall1_supply_open_c">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Supply D</label>
                            <input type="text" v-model="state.autoDrawing.wall1SupplyOpenD" @keyup="checkErrors" class="form-control wall1_supply_open_d">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Width</label>
                            <input type="text" v-model="state.autoDrawing.wall1SupplyOpenWidth" @keyup="checkErrors" class="form-control">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Height</label>
                            <input type="text" v-model="state.autoDrawing.wall1SupplyOpenHeight" @keyup="checkErrors" class="form-control wall1_supply_open_height">
                        </div>
                    </div>
                </div>
            </div>

            <h3 class="spacing_btm">Wall 2</h3>

            <div class="row spacing_btm">
                <div class="col-xs-12 form-group checkbox">
                    <label>
                        <input class="btn btn-default"
                               v-model="state.autoDrawing.toggleWall2Return"
                               type=checkbox
                               :true-value=1
                               :false-value=0
                        >
                        Return Opening
                    </label>
                </div>
            </div>

            <div class="row" v-show="state.autoDrawing.toggleWall2Return">
                <div class="wall2_return">
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Return A</label>
                            <input type="text" v-model="state.autoDrawing.wall2ReturnOpenA" @keyup="checkErrors" class="form-control wall2_return_open_a">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Return B</label>
                            <input type="text" v-model="state.autoDrawing.wall2ReturnOpenB" @keyup="checkErrors" class="form-control wall2_return_open_b">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Width</label>
                            <input type="text" v-model="state.autoDrawing.wall2ReturnOpenWidth" @keyup="checkErrors" class="form-control">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Height</label>
                            <input type="text" v-model="state.autoDrawing.wall2ReturnOpenHeight" @keyup="checkErrors" class="form-control wall2_return_open_height" >
                        </div>
                    </div>
                </div>
            </div>

            <div class="row spacing_btm">
                <div class="col-xs-12 form-group checkbox">
                    <label>
                        <input class="btn btn-default"
                               v-model="state.autoDrawing.toggleWall2Supply"
                               type=checkbox
                               :true-value=1
                               :false-value=0
                        >
                        Supply Opening
                    </label>
                </div>
            </div>

            <div class="row" v-show="state.autoDrawing.toggleWall2Supply">
                <div class="wall2_supply">
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Supply C</label>
                            <input type="text" v-model="state.autoDrawing.wall2SupplyOpenC" @keyup="checkErrors" class="form-control wall2_supply_open_c">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Supply D</label>
                            <input type="text" v-model="state.autoDrawing.wall2SupplyOpenD" @keyup="checkErrors" class="form-control wall2_supply_open_d">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Width</label>
                            <input type="text" v-model="state.autoDrawing.wall2SupplyOpenWidth" @keyup="checkErrors" class="form-control">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Height</label>
                            <input type="text" v-model="state.autoDrawing.wall2SupplyOpenHeight" @keyup="checkErrors" class="form-control wall2_supply_open_height">
                        </div>
                    </div>
                </div>
            </div>

            <h3 class="spacing_btm">Wall 3</h3>

            <div class="row spacing_btm">
                <div class="col-xs-12 form-group checkbox">
                    <label>
                        <input class="btn btn-default"
                               v-model="state.autoDrawing.toggleWall3Return"
                               type=checkbox
                               :true-value=1
                               :false-value=0
                        >
                        Return Opening
                    </label>
                </div>
            </div>

            <div class="row" v-show="state.autoDrawing.toggleWall3Return">
                <div class="wall3_return">
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Return A</label>
                            <input type="text" v-model="state.autoDrawing.wall3ReturnOpenA" @keyup="checkErrors" class="form-control wall3_return_open_a">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Return B</label>
                            <input type="text" v-model="state.autoDrawing.wall3ReturnOpenB" @keyup="checkErrors" class="form-control wall3_return_open_b">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Width</label>
                            <input type="text" v-model="state.autoDrawing.wall3ReturnOpenWidth" @keyup="checkErrors" class="form-control">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Height</label>
                            <input type="text" v-model="state.autoDrawing.wall3ReturnOpenHeight" @keyup="checkErrors" class="form-control wall3_return_open_height">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row spacing_btm">
                <div class="col-xs-12 form-group checkbox">
                    <label>
                        <input class="btn btn-default"
                               v-model="state.autoDrawing.toggleWall3Supply"
                               type=checkbox
                               :true-value=1
                               :false-value=0
                        >
                        Supply Opening
                    </label>
                </div>
            </div>

            <div class="row" v-show="state.autoDrawing.toggleWall3Supply">
                <div class="wall3_supply">
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Supply C</label>
                            <input type="text" v-model="state.autoDrawing.wall3SupplyOpenC" @keyup="checkErrors" class="form-control wall3_supply_open_c">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Supply D</label>
                            <input type="text" v-model="state.autoDrawing.wall3SupplyOpenD" @keyup="checkErrors" class="form-control wall3_supply_open_d">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Width</label>
                            <input type="text" v-model="state.autoDrawing.wall3SupplyOpenWidth" @keyup="checkErrors" class="form-control">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Height</label>
                            <input type="text" v-model="state.autoDrawing.wall3SupplyOpenHeight" @keyup="checkErrors" class="form-control wall3_supply_open_height">
                        </div>
                    </div>
                </div>
            </div>

            <h3 class="spacing_btm">Wall 4</h3>

            <div class="row spacing_btm">
                <div class="col-xs-12 form-group checkbox">
                    <label>
                        <input class="btn btn-default"
                               v-model="state.autoDrawing.toggleWall4Return"
                               type=checkbox
                               :true-value=1
                               :false-value=0
                        >
                        Return Opening
                    </label>
                </div>
            </div>

            <div class="row" v-show="state.autoDrawing.toggleWall4Return">
                <div class="wall4_return">
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Return A</label>
                            <input type="text" v-model="state.autoDrawing.wall4ReturnOpenA" @keyup="checkErrors" class="form-control wall4_return_open_a">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Return B</label>
                            <input type="text" v-model="state.autoDrawing.wall4ReturnOpenB" @keyup="checkErrors" class="form-control wall4_return_open_b">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Width</label>
                            <input type="text" v-model="state.autoDrawing.wall4ReturnOpenWidth" @keyup="checkErrors" class="form-control">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Height</label>
                            <input type="text" v-model="state.autoDrawing.wall4ReturnOpenHeight" @keyup="checkErrors" class="form-control wall4_return_open_height">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row spacing_btm">
                <div class="col-xs-12 form-group checkbox">
                    <label>
                        <input class="btn btn-default"
                               v-model="state.autoDrawing.toggleWall4Supply"
                               type=checkbox
                               :true-value=1
                               :false-value=0
                        >
                        Supply Opening
                    </label>
                </div>
            </div>

            <div class="row" v-show="state.autoDrawing.toggleWall4Supply">
                <div class="wall4_supply">
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Supply C</label>
                            <input type="text" v-model="state.autoDrawing.wall4SupplyOpenC" @keyup="checkErrors" class="form-control wall4_supply_open_c">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Supply D</label>
                            <input type="text" v-model="state.autoDrawing.wall4SupplyOpenD" @keyup="checkErrors" class="form-control wall4_supply_open_d">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Width</label>
                            <input type="text" v-model="state.autoDrawing.wall4SupplyOpenWidth" @keyup="checkErrors" class="form-control">
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <div class="input-group">
                            <label class="input-group-addon">Height</label>
                            <input type="text" v-model="state.autoDrawing.wall4SupplyOpenHeight" @keyup="checkErrors" class="form-control wall4_supply_open_height">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { autoDrawingStore } from "@/components/businessObjects/quote/AutoDrawings/AutoDrawing.store";

    export default {
        name: "Walls",
        props: ["is9999"],
        data() {
            return {
                state: autoDrawingStore.state
            }
        },
        methods: {
            checkErrors: function () {
                autoDrawingStore.checkForErrors();
            }
        },
        computed: {
            baseUrl: function() {
                return process.env.VUE_APP_URL;
            }
        }
    }
</script>

<style scoped>

</style>